<template>
  <div style="width: 100%">
    <h5>Outbound sms</h5>
    <m-field label="To patient">{{ patient.label }}</m-field>
    <m-field label="Message">{{ message }}</m-field>
    <m-field label="Status">{{ status }}</m-field>
    <m-field label="Created at">{{ createdAt }}</m-field>
  </div>
</template>

<script>
import MField from "../../../MField";

export default {
  components: { MField },
  props: {
    status: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    toNumber: {
      type: String,
      default: "",
    },
    patient: {
      type: Object,
      default: null,
    },
    errorCode: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    createdAt: {
      type: String,
      default: "",
    },
    sentAt: {
      type: String,
      default: "",
    },
  },
};
</script>
